export default {
      id: "icon-water-pollution-usage",
      viewBox: "0 0 74.594 44.074",
      url: __webpack_public_path__ + "img/icons.33fd9142.svg#icon-water-pollution",
      toString: function () {
        return this.url;
      }
    }